import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuPortal,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { Role, User } from "types";
import { useState } from "react";
import Icon from "@/icons";
import { useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

export const GiveRole = ({ children, user }: { children: React.ReactNode, user: User }) => {
    const [isOpen, setIsOpen] = useState(false);
    const queryClient = useQueryClient();
    const { teamId } = useParams();
    const roles = (queryClient.getQueryState(["team", teamId, "roles"])?.data as any)?.roles as Role[];
    const filterRolesUserNotHave = roles?.filter((role) => !user?.roles?.includes(role.id)).sort((a, b) => b.priority - a.priority).filter((role) => !role.botScope.userId).filter((role) => role.id !== role.teamId);

    const give = async (role: Role) => {
        const response = await fetch(`__SITE_BASE__/api/v1/teams/${role.teamId}/members/${user.id}/roles/${role.id}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
        });
        const data = await response.json();
        if (data.success) setIsOpen(false);
    }

    const [search, setSearch] = useState("");

    return (
        <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
            <DropdownMenuTrigger asChild>{children}</DropdownMenuTrigger>
            <DropdownMenuPortal>
                <DropdownMenuContent className="w-56 relative bg-brand-default rounded-lg border-0 ml-28 group">
                    <DropdownMenuSeparator />
                    <DropdownMenuGroup className="mb-2 flex flex-col gap-2">
                        <div className="px-1">
                            <input
                                type="text"
                                placeholder="Search roles"
                                className="w-full bg-brand-back text-white  rounded-full p-1 px-3 focus:outline-none"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                            />
                        </div>
                        <div className="max-h-52 overflow-x-hidden sm:overflow-y-hidden group-hover:overflow-y-auto" style={{ scrollbarWidth: "thin", scrollbarColor: "rgb(40, 160, 42) rgb(47 51 58)" }}>
                            {filterRolesUserNotHave?.filter((role:any) => role.name.toLowerCase().includes(search.toLowerCase()))
                            .map((role:any) => (
                                <DropdownMenuItem className="hover:bg-brand-darkest cursor-pointer w-96" key={role.id} onClick={() => give(role)}>
                                    <div
                                        className="w-4 h-4 rounded-full"
                                        style={{
                                            background: role.color2
                                                ? `linear-gradient(90deg, ${role.color}, ${role.color2})`
                                                : role.color,
                                        }}
                                    />
                                    <DropdownMenuLabel>{role.name}</DropdownMenuLabel>
                                </DropdownMenuItem>
                            ))}

                            {filterRolesUserNotHave?.length === 0 && (
                                <div className="flex flex-col items-center text-gray-300 gap-2">
                                    <div className="border border-gray-600 rounded-full p-1">
                                        <Icon name="x" size="12" />
                                    </div>
                                    <h3>All Roles Added</h3>
                                </div>
                            )}
                        </div>
                        <div className="absolute z-10 inset-x-0 bottom-0 h-8 bg-gradient-to-t from-brand-darkest opacity-75"/>

                    </DropdownMenuGroup>
                </DropdownMenuContent>
            </DropdownMenuPortal>
        </DropdownMenu>
    );
};
